module.exports = __webpack_public_path__ + "static/ledeck_01-6444e396606fe15926b749638b743617.webp";